<template>
  <div class="bank-soal-sheet-per-option">

    <modal-confirm :active.sync="dialogSendJawaban"
                   :skipImmediateClose="false"
                   :isLoading="isLoading"
                   :title="`Konfirmasi kirim jawaban`"
                   @confirm="() => doSendJawabanBankSoal()">
      Apakah ada yakin akan mengirim jawaban soal ?
    </modal-confirm>

    <div class="assessment-meta-panel">
      <div class="progress-summary" v-if="soals.length">
        <div>
          <span class="progress-label">Progress asesmen</span>
          <strong>{{ answeredCount }} dari {{ soals.length }} terjawab</strong>
        </div>
        <div class="progress-percent">{{ progressPercentage }}%</div>
        <div class="progress-track" aria-hidden="true">
          <span :style="{ width: progressPercentage + '%' }"></span>
        </div>
      </div>

      <div class="title-soal">
        <div class="info-soal">
          <div :key="index" class="info-soal-item" v-for="(item, index) in infoLembarSoal">
            <div class="info-chip">
              <span>{{ $t('label.' + item.label) }}</span>
              <strong>{{ item.value || '-' }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <card-item :class="`assessment-card font-size-${ukuranFont}`" :header="header" rounded type="info">
      <div class="toolbar media">
        <div class="media-content">
          <g-field is-grouped>
            <div class="control">
              <p class="toolbar-label">Ukuran Font</p>
            </div>
            <div :key="font"
                 class="control" v-for="font in ukuranFonts">
              <g-button :class="font"
                        :type="ukuranFont === font ? 'info' : ''"
                        @click="ukuranFont = font">
                A
              </g-button>
            </div>
          </g-field>
        </div>
        <div class="media-right" v-if="!($scopedSlots.default || $slots.default)">
          <g-field is-grouped>
            <div class="control">
              <g-dropdown class="dropdown-search-input" position="bottom-left">
                <g-button class="has-icon" is-outlined
                          slot="trigger" type="link">
                  <span class="icon"><i class="far fa-list-ol"></i></span>
                  <span>Daftar Soal dan Jawaban</span>
                </g-button>

                <template>
                  <div class="info-preview-soal">
                    <p class="title is-6">Nomor Soal</p>
                  </div>
                  <div :key="previewSoalKey"
                       class="preview-soal columns is-multiline">
                    <div :key="soal.nomor" v-show="soal.show"
                         class="column is-3" v-for="soal in previewSoals">
                      <g-button :type="soal.nomor === aktifNomor ? 'info' : ''"
                                @click="goToSoal(soal.nomor)">
                        {{ soal.nomor }}
                      </g-button>
                      <div class="dot-jawaban" v-if="soal.jawaban && soal.jawaban !== ''">
                        {{ soal.jawaban.toUpperCase() }}
                      </div>
                    </div>
                  </div>
                </template>
              </g-dropdown>
            </div>
            <div class="control">
              <g-button @click="logout"
                        type="danger">
                <span>Keluar</span>
                <span class="icon"><i class="far fa-power-off"></i></span>
              </g-button>
            </div>
          </g-field>
        </div>
      </div>

      <template v-if="$scopedSlots.default || $slots.default">
        <slot></slot>
      </template>

      <template v-else-if="currentSoal">
        <div :key="currentSoalKey" class="content-soal">

          <div class="question-eyebrow">
            <span>Soal {{ aktifNomor }}</span>
            <span v-if="currentSoal.aspek">{{ currentSoal.aspek }}</span>
          </div>

          <div class="question-text content" :class="ukuranFont" v-html="currentSoal.soal"></div>

          <div class="columns is-multiline">
            <div :key="wIndex" class="column is-6" v-for="(word, wIndex) in options">
              <div class="option-row media"
                   :class="{ 'is-selected': currentSoal.jawaban === word }"
                   @click="selectOption(word)"
                   v-if="currentSoal['pilihan_'+word] != ''">
                <div class="media-left">
                  <g-field :class="ukuranFont" class="field-option" is-grouped>
                    <div class="control tooltip" data-tooltip="Klik opsi ini untuk men set sebagai jawaban"
                         v-if="currentSoal">
                      <g-radiobutton :key="`${currentSoalKey}-${word}`"
                                     :name="`option-${currentSoalKey}`" :native-value="word"
                                     @on-selected="onSelectOption"
                                     v-model="currentSoal.jawaban"/>
                    </div>
                    <div class="control"><p>{{ word.toUpperCase() }}.</p></div>
                  </g-field>
                </div>
                <div class="media-content">
                  <div :class="ukuranFont" class="option-content content"
                       v-html="currentSoal['pilihan_'+word]">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="footer-soal level">
          <div class="level-item">
            <g-button class="navigation-button"
                      :disabled="aktifNomor === 1" @click="goToSoal(aktifNomor - 1)"
                      type="danger">
              <span class="icon"><i class="far fa-chevron-left"></i></span>
              <span>Soal Sebelumnya</span>
            </g-button>
          </div>
          <div class="level-item" v-if="soals.length == aktifNomor">
            <g-button class="navigation-button"
                      type="success" @click="doDialogSendJawaban()" :is-loading="isLoading">
              <span>Kirim Jawaban</span>
              <span class="icon"><i class="far fa-send"></i></span>
            </g-button>
          </div>
          <div class="level-item">
            <g-button class="navigation-button"
                      :disabled="aktifNomor === soals.length"
                      @click="goToSoal(aktifNomor + 1)"
                      type="primary">
              <span>Soal Selanjutnya</span>
              <span class="icon"><i class="far fa-chevron-right"></i></span>
            </g-button>
          </div>
        </div>

      </template>
    </card-item>

  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Container, Watch } from 'annotation';
import BankSoal from "../../entity/BankSoal";
import AsesmenPendaftar from "../../entity/AsesmenPendaftar";
import {toListFormated} from "../../util/Underscore";
import GField from "./common/field/GField.vue";
import GRadiobutton from "./common/radio-button/GRadiobutton.vue";
import GButton from "./common/button/GButton.vue";
import GSelect from "./common/select/GSelect.vue";
import CardItem from "./CardItem.vue";
import Soal from "../../entity/Soal";
import {getJenisKelamin, getPenerimaDana} from "../../util/PluralVariabels";
import JawabanBankSoal from "../../entity/JawabanBankSoal";
import Response from "../../service/Response";
import BankSoalService from "../../service/BankSoalService";
import Notification from "../../Notification";
import Authentication from "../../Authentication";
import ModalConfirm from "./ModalConfirm.vue";
import GDropdown from "./common/dropdown/GDropdown.vue";
import Storage from "../../Storage";

@Component({
  components: {GDropdown, ModalConfirm, CardItem, GSelect, GButton, GRadiobutton, GField}
})
export default class BankSoalSheetPerOptions extends Vue {

  @Prop({type: AsesmenPendaftar, default: new AsesmenPendaftar()})
  public asesmen: AsesmenPendaftar;

  @Prop({type: BankSoal, default: new BankSoal()})
  public bankSoal: BankSoal;

  @Prop({type: BankSoal, default: Array<Soal>()})
  public soals: Array<Soal>;

  public aktifNomor: number = 1;

  public ukuranFonts: Array<string> = ['small', '', 'large', 'very-large'];

  public ukuranFont: string = this.ukuranFonts[1];

  public options: Array<string> = ["a", "b", "c", "d", "e"];

  public get bankSoalService(): BankSoalService {
    return Container.get(BankSoalService);
  }

  public jawabanBankSoal: JawabanBankSoal = new JawabanBankSoal();

  public isLoading: boolean = false

  public dialogSendJawaban: boolean = false;

  public previewSoalKey: string = Math.random().toString();

  public hasRestoredDraft: boolean = false;

  public readonly draftStoragePrefix: string = 'asesmen-draft-jawaban';

  public get infoLembarSoal() {
    let param = {
      nomor: this.asesmen.nomor,
      nama: this.asesmen.nama_lengkap,
      jenis_kelamin: getJenisKelamin(this.asesmen.jenis_kelamin),
      orang_tua: this.asesmen.orang_tua,
      pendidikan: getPenerimaDana(this.asesmen.pendidikan),
      sekolah_asal: this.asesmen.sekolah_asal,
    };

    return toListFormated(param);
  }

  public get previewSoals() {
    return this.soals.reduce((accu: Array<any>, item: Soal, index: number) => {
      const hasJawaban = this.soals[index].jawaban;
      let jawaban = "";
      if (hasJawaban) {
        jawaban = this.soals[index].jawaban;
      }

      accu.push({nomor: index + 1, jawaban: jawaban, show: true});
      return accu;
    }, []);
  }

  public get index() {
    return this.aktifNomor - 1;
  }

  public get answeredCount(): number {
    return this.soals.filter((soal: Soal) => soal.jawaban && soal.jawaban !== '').length;
  }

  public get progressPercentage(): number {
    if (!this.soals.length) {
      return 0;
    }

    return Math.round((this.answeredCount / this.soals.length) * 100);
  }

  public get currentSoal(): Soal | null {
    return this.soals[this.index] || null;
  }

  public get currentSoalKey(): string {
    const soal = this.currentSoal;

    if (!soal) {
      return `${this.index}`;
    }

    return `${soal.id || soal.nomor || this.index}`;
  }

  public get draftStorageKey(): string {
    const nomor = this.asesmen.nomor || 'tanpa-nomor';
    const bankSoalId = this.bankSoal.id || this.asesmen.pendidikan || 'bank-soal';

    return `${this.draftStoragePrefix}-${nomor}-${bankSoalId}`;
  }

  public get header() {
    const title = `Pertanyaan ke ${this.aktifNomor}`;

    return {title, icon: 'far fa-list-alt'}
  }

  public goToSoal(no: number = 1) {
    if (no !== 0 && no !== this.soals.length + 1) {
      this.aktifNomor = no;
      this.saveDraftJawaban();
    }
  }

  public getSoalDraftKey(soal: Soal, index: number): string {
    return `${soal.id || soal.nomor || index}`;
  }

  public selectOption(word: string) {
    if (!this.currentSoal) {
      return;
    }

    this.currentSoal.jawaban = word;
    this.saveDraftJawaban();
  }

  public saveDraftJawaban() {
    if (!this.soals.length || !this.asesmen.nomor) {
      return;
    }

    const jawabans = this.soals.reduce((accu: any, soal: Soal, index: number) => {
      if (soal.jawaban && soal.jawaban !== '') {
        accu[this.getSoalDraftKey(soal, index)] = soal.jawaban;
      }

      return accu;
    }, {});

    Storage.getLocalStorage().set(this.draftStorageKey, {
      aktifNomor: this.aktifNomor,
      jawabans,
    });
  }

  public restoreDraftJawaban() {
    if (this.hasRestoredDraft || !this.soals.length || !this.asesmen.nomor) {
      return;
    }

    const draft: any = Storage.getLocalStorage().get(this.draftStorageKey);
    const jawabans = draft && draft.jawabans ? draft.jawabans : {};

    this.soals.forEach((soal: Soal, index: number) => {
      const jawaban = jawabans[this.getSoalDraftKey(soal, index)];

      if (jawaban) {
        this.$set(soal, 'jawaban', jawaban);
      }
    });

    if (draft && draft.aktifNomor > 0 && draft.aktifNomor <= this.soals.length) {
      this.aktifNomor = draft.aktifNomor;
    }

    this.hasRestoredDraft = true;
  }

  public clearDraftJawaban() {
    Storage.getLocalStorage().remove(this.draftStorageKey);
  }

  public async logout() {
    this.clearDraftJawaban();
    Authentication.removeAsesmen();

    // Go to home page
    window.location.href = '/';
  }

  public onSelectOption() {
    this.$nextTick(() => this.saveDraftJawaban());
  }

  @Watch('soals', {deep: true})
  public onSoalsChanged() {
    this.restoreDraftJawaban();
  }

  public async doDialogSendJawaban() {
    let valid = true
    this.soals.forEach(value => {
      if (value.jawaban == "") {
        valid = false
      }
    })

    if (!valid) {
      Notification.showNotification({
        text: 'Belum semua terjawab',
        title: `Terdapat soal yang belum ada jawab, Silahkan cek kembali`
      }, true);
    } else {
      this.dialogSendJawaban = true
    }
  }

  public async doSendJawabanBankSoal() {
    this.isLoading = false;
    this.jawabanBankSoal.bank_soal_id = this.bankSoal.id
    this.jawabanBankSoal.nomor = this.asesmen.nomor
    this.jawabanBankSoal.nama_lengkap = this.asesmen.nama_lengkap
    this.jawabanBankSoal.jenis_kelamin = this.asesmen.jenis_kelamin
    this.jawabanBankSoal.orang_tua = this.asesmen.orang_tua
    this.jawabanBankSoal.sekolah_asal = this.asesmen.sekolah_asal
    this.jawabanBankSoal.jawabans = this.soals;
    let response: Response = await this.bankSoalService.doSendJawaban(this.jawabanBankSoal);
    if (response.statusResponse == 200) {
      this.clearDraftJawaban();
      Authentication.removeAsesmen();

      // Go to home page
      window.location.href = '/';
    } else {
      Notification.showNotification({
        text: 'Gagal kirim jawaban',
        title: `Gagal mengirim jawaban, Silahkan hubungi admin`
      }, true);
    }

    this.isLoading = false;
  }

}
</script>

<style lang="scss">
@import "../../style/variables_function";

.bank-soal-sheet-per-option {
  --assessment-primary: #{$modern-primary};
  --assessment-primary-dark: #{$modern-primary-dark};
  --assessment-surface: rgba(255, 255, 255, .86);
  --assessment-border: rgba(148, 163, 184, .22);
  --assessment-text: #{$text-primary};
  --assessment-muted: #{$text-secondary};

  font-family: $font-body;

  .assessment-meta-panel {
    margin-bottom: 12px;
    padding: 12px;
    border: 1px solid var(--assessment-border);
    border-radius: $radius-lg;
    background: var(--assessment-surface);
    box-shadow: $shadow-lg;
    backdrop-filter: blur(18px);
  }

  .progress-summary {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px 18px;
    align-items: center;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid rgba(148, 163, 184, .18);

    .progress-label {
      display: block;
      margin-bottom: 2px;
      color: var(--assessment-muted);
      font-size: .70rem;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: .08em;
    }

    strong {
      color: var(--assessment-text);
      font-family: $font-display;
      font-size: 1rem;
      font-weight: 900;
      letter-spacing: 0;
    }

    .progress-percent {
      color: var(--assessment-primary-dark);
      font-family: $font-display;
      font-size: 1.35rem;
      font-weight: 900;
      line-height: 1;
    }

    .progress-track {
      grid-column: 1 / -1;
      height: 7px;
      overflow: hidden;
      border-radius: $radius-full;
      background: #e2e8f0;

      span {
        display: block;
        height: 100%;
        border-radius: inherit;
        background: $modern-gradient;
        box-shadow: 0 0 24px rgba(5, 150, 105, .28);
        transition: width $transition-base;
      }
    }
  }

  .title-soal {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;

    .info-soal {
      display: grid !important;
      grid-template-columns: repeat(6, minmax(0, 1fr));
      gap: 10px;
      justify-content: stretch !important;
      align-items: stretch;
      padding-bottom: 0 !important;
      flex-wrap: initial !important;
    }

    .info-soal-item {
      display: block !important;
      width: auto !important;
      margin-bottom: 0 !important;
      min-width: 0;
    }

    .info-chip {
      height: 100%;
      min-height: 50px;
      padding: 8px 10px;
      border: 1px solid rgba(226, 232, 240, .9);
      border-radius: $radius-md;
      background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);

      span {
        display: block;
        margin-bottom: 5px;
        color: $text-muted;
        font-size: .72rem;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: .06em;
      }

      strong {
        display: block;
        color: var(--assessment-text);
        font-size: .94rem;
        font-weight: 800;
        line-height: 1.35;
        word-break: break-word;
      }
    }
  }

  .assessment-card.card {
    overflow: hidden;
    border: 1px solid rgba(148, 163, 184, .18);
    border-radius: $radius-lg;
    background: rgba(255, 255, 255, .94);
    box-shadow: 0 28px 80px rgba(15, 23, 42, .13);

    > .card-header {
      min-height: 48px;
      border: 0;
      background: linear-gradient(135deg, $surface-dark 0%, $modern-primary-dark 54%, #0d9488 100%);
      box-shadow: none;
    }

    .card-header-title {
      color: $text-on-dark;
      font-family: $font-display;
      font-size: 1rem;
      font-weight: 900;
      letter-spacing: 0;
    }

    .card-header-icon {
      color: rgba(255, 255, 255, .8);
    }
  }

  .card-content {
    padding: 0;

    .has-no-content {
      margin: 1.25rem 0;
    }
  }

  .toolbar {
    margin: 0;
    padding: 10px 18px;
    border-bottom: 1px solid rgba(148, 163, 184, .18);
    background: #f8fafc;

    .toolbar-label {
      color: var(--assessment-muted);
      font-size: .84rem;
      font-weight: 800;
    }

    .media-content {
      .is-grouped {
        align-items: center;
      }

      .button {
        width: 32px;
        height: 32px;
        border-radius: $radius-sm;
        font-weight: 900;
      }

      .button.small {
        font-size: .8rem;
      }

      .button.large {
        font-size: 1.25rem;
      }

      .button.very-large {
        font-size: 1.50rem;
      }
    }

    .media-right {
      .dropdown-menu {
        width: 280px;
        margin-top: .5rem;

        .dropdown-content {
          border: 1px solid rgba(148, 163, 184, .22);
          border-radius: $radius-md;
          overflow: auto;
          box-shadow: $shadow-xl;
        }
      }

      .info-preview-soal {
        background: $modern-gradient;
        margin: -.5rem 0 0;
        padding: .75rem;

        p {
          color: white;
        }
      }

      .preview-soal {
        margin: 0;
        max-height: 260px;
        padding: 10px;

        .column.is-3 {
          position: relative;
          text-align: center;
          padding: 6px;
        }

        .button {
          width: 100%;
          border-radius: $radius-sm;
          font-weight: 900;
        }

        .dot-jawaban {
          position: absolute;
          top: 0;
          right: 0;
          background: $accent-gold;
          width: 19px;
          height: 19px;
          border-radius: 50%;
          color: $surface-dark;
          font-size: .68rem;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .dot-ragu2 {
          position: absolute;
          top: 5px;
          right: 5px;
          background-color: $yellow;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          color: white;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .content-soal {
    margin: 0;
    padding: 10px 24px 18px;

    .question-eyebrow {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      align-items: center;
      margin-bottom: 8px;

      span {
        display: inline-flex;
        align-items: center;
        min-height: 24px;
        padding: 4px 10px;
        border-radius: $radius-full;
        background: rgba(5, 150, 105, .1);
        color: $modern-primary-dark;
        font-size: .78rem;
        font-weight: 900;
      }

      span + span {
        background: rgba(245, 158, 11, .14);
        color: #b45309;
      }
    }

    .question-text {
      margin-bottom: 14px;
      padding: 14px 18px;
      border-left: 5px solid var(--assessment-primary);
      border-radius: $radius-md;
      background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
      color: var(--assessment-text);
      box-shadow: $shadow-sm;

      p:last-child {
        margin-bottom: 0;
      }
    }

    .columns.is-multiline {
      margin: -7px;

      > .column {
        padding: 7px;
      }
    }

    .option-row {
      min-height: 66px;
      height: 100%;
      margin: 0;
      padding: 10px 16px;
      border: 1px solid rgba(148, 163, 184, .26);
      border-radius: $radius-md;
      background: #ffffff;
      cursor: pointer;
      transition: transform $transition-fast, border-color $transition-fast, box-shadow $transition-fast, background $transition-fast;

      &:hover {
        transform: translateY(-2px);
        border-color: rgba(5, 150, 105, .35);
        box-shadow: 0 14px 30px rgba(15, 23, 42, .08);
      }

      &.is-selected {
        border-color: rgba(5, 150, 105, .62);
        background: linear-gradient(135deg, rgba(5, 150, 105, .1), rgba(8, 145, 178, .06));
        box-shadow: 0 18px 42px rgba(5, 150, 105, .13);

        .field-option {
          border-color: $modern-primary;
          background: $modern-primary;
          color: white;
        }
      }
    }

    .field-option {
      align-items: center;
      min-width: 66px;
      justify-content: center;
      padding: .35rem .65rem;
      border-radius: $radius-full;
      border: 1.5px solid rgba(148, 163, 184, .42);
      color: var(--assessment-text);
      background: #f8fafc;

      .control.tooltip {
        display: flex;
      }

      p {
        margin: 0;
        font-weight: 900;
      }
    }

    .option-content {
      color: var(--assessment-text);
      font-size: 1rem;
      line-height: 1.7;

      p:last-child {
        margin-bottom: 0;
      }
    }

    .question-text.small,
    .question-text.small *,
    .option-content.small,
    .option-content.small *,
    .field-option.small p {
      font-size: .8rem !important;
    }

    .question-text.large,
    .question-text.large *,
    .option-content.large,
    .option-content.large *,
    .field-option.large p {
      font-size: 1.25rem !important;
    }

    .question-text.very-large,
    .question-text.very-large *,
    .option-content.very-large,
    .option-content.very-large *,
    .field-option.very-large p {
      font-size: 1.50rem !important;
    }
  }

  .footer-soal {
    margin: 0;
    padding: 8px 18px;
    border-top: 1px solid rgba(148, 163, 184, .18);
    background: #f8fafc;

    .level-item {
      &:first-child {
        justify-content: flex-start;
      }

      &:last-child {
        justify-content: flex-end;
      }
    }

    .navigation-button.button {
      min-height: 42px;
      padding-right: 18px;
      padding-left: 18px;
      border-radius: $radius-sm;
      font-size: .98rem;
      font-weight: 900;
      box-shadow: $shadow-sm;
    }
  }
}

@media screen and (max-width: $tablet_size_max) {
  .bank-soal-sheet-per-option {
    .title-soal .info-soal {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .toolbar.media {
      display: block;

      .media-right {
        margin-top: 14px;
      }
    }

    .content-soal {
      padding: 10px 22px 22px;
    }
  }
}

@media screen and (max-width: $mobile_size) {
  .bank-soal-sheet-per-option {
    .assessment-meta-panel {
      padding: 14px;
      border-radius: $radius-md;
    }

    .progress-summary {
      grid-template-columns: 1fr;

      .progress-percent {
        font-size: 1.35rem;
      }
    }

    .title-soal .info-soal {
      grid-template-columns: 1fr;
    }

    .assessment-card.card {
      border-radius: $radius-md;

      .card-header-title {
        font-size: 1rem;
      }
    }

    .toolbar {
      padding: 14px;

      .field.is-grouped {
        flex-wrap: wrap;
      }
    }

    .content-soal {
      padding: 8px 14px 16px;

      .question-text {
        padding: 14px 16px;
      }

      .option-row {
        min-height: auto;
        padding: 14px 12px;
      }
    }

    .footer-soal.level {
      display: grid;
      gap: 10px;
      padding: 14px;

      .level-item,
      .level-item:first-child,
      .level-item:last-child {
        justify-content: stretch;
      }

      .navigation-button.button {
        width: 100%;
        min-height: 44px;
      }
    }
  }
}
</style>
